import Swiper, { Navigation, Pagination, Scrollbar } from 'swiper';
import $ from "jquery";

$(document).ready(function() {

	if ($(window).width() < 768) {
		const jsliderEvents = new Swiper(".jsSliderEvents .slider__init", {
			modules: [Scrollbar],
			slidesPerView: 1,
			spaceBetween: 16,
			scrollbar: {
				el: '.jsSliderEvents .swiper-scrollbar',
				draggable: true,
			},
		});
	}

	if ($(window).width() < 480) {
		const sliderEventsSm = new Swiper(".jsSliderEventsSm .slider__init", {
			modules: [Scrollbar],
			slidesPerView: 1,
			spaceBetween: 16,
			scrollbar: {
				el: '.jsSliderEventsSm .swiper-scrollbar',
				draggable: true,
			},
		});
	}


	document.querySelectorAll('.jsSliderBasic').forEach(slider => {
		const sliderBasic = new Swiper(slider.querySelector('.slider__init'), {
			modules: [Scrollbar, Navigation],
			slidesPerView: 1,
			spaceBetween: 16,
			scrollbar: {
				el: '.jsSliderBasic .swiper-scrollbar',
				draggable: true,
			},
			navigation: {
				prevEl: slider.querySelector('.jsSliderBtnPrev'),
				nextEl: slider.querySelector('.jsSliderBtnNext'),
			},
		});
	});


	document.querySelectorAll('.jsSliderArticle').forEach(slider => {
		const sliderArticle = new Swiper(slider.querySelector('.slider__init'), {
			modules: [Scrollbar, Navigation],
			slidesPerView: 'auto',
			spaceBetween: 24,
			scrollbar: {
				el: '.jsSliderArticle .swiper-scrollbar',
				draggable: true,
			},
			navigation: {
				prevEl: slider.querySelector('.jsSliderBtnPrev'),
				nextEl: slider.querySelector('.jsSliderBtnNext'),
			},
		});
	});


	$('.jsSliderTags').each(function () {
		const that = $(this);

		let summ =0 ;
		that.find('.swiper-slide').each(function(){
			summ += 1*$(this).width();
		});

		if (summ >= that.width()) {
			that.find('.slider__buttons').addClass('d-flex')

			const sliderTags = new Swiper(('.jsSliderTags .slider__init'), {
				modules: [Scrollbar, Navigation],
				slidesPerView: 'auto',
				watchSlidesProgress: true,
				spaceBetween: 4,
				navigation: {
					prevEl: ('.jsSliderTags .jsSliderBtnPrev'),
					nextEl: ('.jsSliderTags .jsSliderBtnNext'),
				},
			});
		}
	});


})






